;(function () {
  'use strict';

  let angular = window.angular;
  let $ = window.$;

  GISUploadController.$inject = ['AppUtils', '$scope'];

  angular
    .module('app')
    .component('gisUploadForm', {
      template:'<form name="ctrl.gisUploadForm" class="validate form-full" novalidate><div class="modal-header"><span translate>buttons.load</span> Geo Data</div><div class="modal-body"><div class="text-center"><div class="btn-group" data-toggle="buttons"><label class="btn btn-primary" ng-class="{active: ctrl.file.format == \'kml\'}" ng-click="ctrl.setFileFormat(\'kml\')" style="min-width: 120px"><input type="radio" name="ctrl.file.format" value="kml" id="KMLCheck"> KML</label> <label class="btn btn-primary" ng-class="{active: ctrl.file.format == \'json\'}" ng-click="ctrl.setFileFormat(\'json\')" for="JSONCheck" style="min-width: 120px"><input type="radio" name="ctrl.file.format" value="json" id="JSONCheck"> GeoJSON</label></div></div><div class="form-group marginT20"><label><span translate>general.file</span> <span class="help"><span translate>form.messages.maxSize</span> {{ctrl.maxSize | bytes}}</span></label><div class="form-group input-file" show-errors><span class="button"><input ng-if="ctrl.file.format == \'kml\'" file-model="ctrl.file.data" accept=".kml" type="file"> <input ng-if="ctrl.file.format == \'json\'" file-model="ctrl.file.data" accept=".json, .geojson" type="file"> <span translate>buttons.browse</span></span> <input name="file" class="form-control" translate-attr="{placeholder: \'general.file\'}" ng-model="ctrl.file.data.name" readonly required><div class="help-block" ng-messages="ctrl.gisUploadForm.file.$error"><span ng-message="FILE_SIZE_EXCEEDED" translate>errors.FILE_SIZE_EXCEEDED</span></div></div></div></div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-disabled="!ctrl.file.data" ng-click="ctrl.uploadKML()" ng-if="ctrl.file.format == \'kml\'"><i class="fas fa-fw" ng-class="{\'fa-upload\': !ctrl.file.uploading, \'fa-cog fa-spin\': ctrl.file.uploading}"></i> <span translate>buttons.upload</span></button> <button class="btn btn-primary" ng-disabled="!ctrl.file.data" ng-click="ctrl.uploadGeoJSON()" ng-if="ctrl.file.format == \'json\'"><i class="fas fa-fw" ng-class="{\'fa-upload\': !ctrl.file.uploading, \'fa-cog fa-spin\': ctrl.file.uploading}"></i> <span translate>buttons.upload</span></button></div></form>',
      controller: GISUploadController,
      controllerAs: 'ctrl',
      bindings: {
        modalInstance: '<',
        resolve: '<'
      }
    });

  function GISUploadController (utils, $scope) {
    let vm = this;
    const MAX_FILE_SIZE = 2048 * 1024;
    vm.$onInit = function onInit () {
      vm.file = { data: null, format: 'kml', uploading: false };
      vm.uploadKML = uploadKML;
      vm.uploadGeoJSON = uploadGeoJSON;
      vm.setFileFormat = setFileFormat;

      const maxSize = vm.resolve.maxKB;
      vm.maxSize = utils.isValidNumber(maxSize) && maxSize ? maxSize * 1024 : MAX_FILE_SIZE;
    };

    function checkFile (file) {
      let fileSize = file.size;
      return fileSize < vm.maxSize;
    }

    function setFileFormat (format) {
      vm.file.data = null;
      vm.file.format = format;
    }

    function uploadKML () {
      upLoadFile(function (e) {
        vm.file.uploading = false;
        let content = e.target.result;

        let dom = (new DOMParser()).parseFromString(content, 'text/xml');
        let json = toGeoJSON.kml(dom);

        vm.modalInstance.close(json);
      });
    }

    function uploadGeoJSON () {
      upLoadFile(function (e) {
        vm.file.uploading = false;
        let content = e.target.result;
        let json = JSON.parse(content);
        vm.modalInstance.close(json);
      });
    }

    function upLoadFile (onLoad) {
      vm.file.uploading = true;

      try {
        let reader = new FileReader();

        reader.onload = onLoad;

        if (checkFile(vm.file.data)) {
          vm.gisUploadForm.file.$setValidity('FILE_SIZE_EXCEEDED', true);
          reader.readAsText(vm.file.data);
        } else {
          vm.file.uploading = false;
          vm.gisUploadForm.file.$setValidity('FILE_SIZE_EXCEEDED', false);
        }
        $scope.$broadcast('show-errors-check-validity');
      } catch (e) {
        vm.file.uploading = false;
        vm.modalInstance.dismiss(e);
      }
    }
  }
})();
